//
//
import { vReporterStore } from '@/pages/Management/violations/Reporter/store.js'
//
export function mounted() {
  this.unsubViolationAdderStore = vReporterStore.subscribe(() => {
    this.updateData()
  })
}
